export * from './tab-layout.component';



// WEBPACK FOOTER //
// ./src/app/containers/tab-layout/index.ts